import { Component, Output, ViewChild, EventEmitter, AfterViewChecked, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MemberDevice } from '../members.interfaces';
import { MemberService } from '../services/member.service';
const alertify = require('alertify.js');

declare var jQuery: any;

interface MemberDeviceTableRow {
  token: string;
  createdAt: string;
  updatedAt: string;
  isValid: boolean;
  isLocationKnown: boolean;
  platform: string;
  appVersion: string;
  installationId: string;
}

@Component({
  selector: 'ch-devices-modal-dialog',
  templateUrl: './devices-modal-dialog.component.html',
  styleUrls: ['./devices-modal-dialog.component.css'],
})
export class DevicesModalDialogComponent implements OnChanges, AfterViewChecked {
  @Input() public show: boolean;
  @Input() public memberId: string;
  @Output() public close: EventEmitter<any> = new EventEmitter();
  @ViewChild('modal') private modal;
  private change: boolean;

  public loading = false;
  public devices: MemberDeviceTableRow[] = [];

  constructor(private memberService: MemberService) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.show && this.show) {
      this.change = true;
      this.getDevices();
    }
  }

  ngAfterViewChecked() {
    if (this.change) {
      jQuery(this.modal.nativeElement)
        .modal({
          backdrop: false,
        })
        .on('hidden.bs.modal', e => {
          this.close.emit(e);
        });

      this.change = false;
    }
  }

  private getDevices() {
    if (!this.memberId) {
      this.devices = [];
      return;
    }

    this.loading = true;
    this.memberService.getMemberDevices(this.memberId).subscribe(
      devices => {
        this.devices = (devices || [])
          .map(device => this.toTableRow(device))
          .sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime());
        this.loading = false;
      },
      error => {
        this.loading = false;
        this.alertError(error);
      }
    );
  }

  private toTableRow(device: MemberDevice): MemberDeviceTableRow {
    return {
      token: this.tokenValue(device.token),
      createdAt: device.createdAt,
      updatedAt: device.updatedAt,
      isValid: device.isValid === true,
      isLocationKnown: device.coordinates,
      platform: device.platform || '-',
      appVersion: device.appVersion || '-',
      installationId: device.installationId || '-',
    };
  }

  private tokenValue(token: string | null): string {
    if (!token || token.trim() === '') {
      return '-';
    }

    return token;
  }

  private alertError(error: any) {
    if (!error.error) {
      alertify.error(`There was a ${error.status} error with the request.`);
    } else {
      alertify.error(
        `There was a ${error.status} error with message '${error.error}'.`
      );
    }
  }
}



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/member/devices-modal-dialog/devices-modal-dialog.component.ts